import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import {
  Table,
  Empty,
  Button,
  Tag,
  Space,
  message,
  Tooltip,
  Typography,
  Divider,
  Dropdown,
  Menu,
  Modal,
  Upload,
  Alert,
  Input,
  Row,
  Col,
} from "antd";
import {
  MoreOutlined,
  UserAddOutlined,
  EditOutlined,
  DeleteOutlined,
  ExportOutlined,
  DownOutlined,
  UploadOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

import closeIcon from "../../../assets/icons/close.svg";

import "./UsersAdmin.css"; // Importing CSS

import Back from "../../../assets/back-btn.svg";

import searchIconsvg from "../../../assets/icons/Search-Icon.svg";

import viewIcon from "../../../assets/icons/Eye.svg";
import editIcon from "../../../assets/icons/Edit.svg";
import deleteIcon from "../../../assets/icons/Delete.svg";
import CustomBreadcrumb from "../../../components/shared/breadcrumbs/CustomBreadCrumb";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import CustomPopover from "../../../components/shared/custompopover/CustomPopover";
import CustomTab from "../../../components/shared/tab/TabComponent";

import CommonTable from "../../../components/shared/table/Table";
import UsersModal from "./UsersModal";
import ConfirmDeletePopup from "../../../components/shared/confirmDeletePopup/ConfirmDeletePopup";
import PDFReaderModal from "../../../components/admin/booksAdmin/PDFReaderModal";
import UserReportOptionsModal from "../../../components/admin/booksAdmin/UserReportOptionsModal";

import CustomSelector from "../../../components/shared/Input/Custom-Selector";
import {
  deleteUsers,
  downloadUserReportExcel,
  downloadUserReportPdf,
  fetchAllActiveUsers,
  fetchAllInactiveUsers,
  previewUserReportPdf,
} from "../../../service/UserService";
import Toast from "../../../components/shared/toast/Toast";
import AdminHOC from "../../../components/shared/HOC/AdminHOC";
import { app } from "../../../service/serviceLMS";
import CustomButton from "../../../components/global/Button/CustomButton";
import CustomModal from "../../../components/global/CustomModal/CustomModal";
import CustomInput from "../../../components/global/CustomInput/CustomInput";

const { Title } = Typography;
const { Search } = Input;
const UsersAdmin = ({ setLoading, setHeader, setBreadCrumbs }) => {
  const navigate = useNavigate();

  const [isInactive, setIsInactive] = useState(false);
  const [userList, setUserList] = useState([]);
  const [inactiveUserList, setInactiveUserList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState(null);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportBlobUrl, setReportBlobUrl] = useState("");
  const [reportingUserId, setReportingUserId] = useState(null);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [reportOptions, setReportOptions] = useState(null);
  const [downloadFormat, setDownloadFormat] = useState(null);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [isPreValidateModalOpen, setIsPreValidateModalOpen] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const [validating, setValidating] = useState(false);
  const [isValidationSuccessful, setIsValidationSuccessful] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isInputHovered, setIsInputHovered] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortDir, setSortDir] = useState("desc");
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [activeTab, setActiveTab] = useState("1");

  async function getUserLists() {
    try {
      setLoading(true);

      if (isInactive) {
        const inactiveResponse = await fetchAllInactiveUsers(
          currentPage - 1,
          pageSize,
          sortBy,
          sortDir,
        );

        if (inactiveResponse.data.content) {
          setInactiveUserList(inactiveResponse.data.content);
          setTotalElements(inactiveResponse.data.totalElements);
        } else {
          setInactiveUserList(inactiveResponse.data);
          setTotalElements(inactiveResponse.data.length);
        }
      } else {
        const activeResponse = await fetchAllActiveUsers(
          currentPage - 1,
          pageSize,
          sortBy,
          sortDir,
        );

        if (activeResponse.data.content) {
          setUserList(activeResponse.data.content);
          setTotalElements(activeResponse.data.totalElements);
        } else {
          setUserList(activeResponse.data);
          setTotalElements(activeResponse.data.length);
        }
      }
    } catch (error) {
      message.error("Failed to load users");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getUserLists();
  }, [currentPage, pageSize, sortBy, sortDir, isInactive]);

  const handleTableChange = (pagination, filters, sorter) => {
    // Handle pagination
    if (pagination) {
      setCurrentPage(pagination.current);
      if (pagination.pageSize !== pageSize) {
        setPageSize(pagination.pageSize);
        setCurrentPage(1);
      }
    }

    // Handle sorting
    if (sorter && sorter.field) {
      setSortBy(sorter.field);
      setSortDir(sorter.order === "ascend" ? "asc" : "desc");
    }
  };

 

  const handleReportOptionsSubmit = async (options) => {
    try {
      setShowOptionsModal(false);
      setReportOptions(options);

      const blob = await previewUserReportPdf(options);
      const blobUrl = URL.createObjectURL(blob);
      setReportBlobUrl(blobUrl);
      setIsReportModalOpen(true);
    } catch (err) {
      message.error("Failed to generate report");
    }
  };

  const bulkUploadUsers = async (formData) => {
    return app.post("/user/api/client-api/admin/bulk-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
  const handleUploadSubmit = async () => {
    if (!selectedFile) {
      message.error("Please select a file first.");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);

      await bulkUploadUsers(formData);

      message.success("Users uploaded successfully!");
      setIsDownloadModalOpen(false);
      setSelectedFile(null);
      setFileList([]);
      getUserLists(); // refresh table
    } catch (error) {
      message.error("Upload failed!", error);
    } finally {
      setUploading(false);
    }
  };

  const handleDownloadPdf = async () => {
    try {
      await downloadUserReportPdf(reportOptions);
      message.success("PDF downloaded successfully");
    } catch {
      message.error("Failed to download PDF");
    }
  };

  const handleDownloadExcel = async () => {
    try {
      await downloadUserReportExcel(reportOptions);
      message.success("Excel downloaded successfully");
    } catch {
      message.error("Failed to download Excel");
    }
  };

  const handleAddNew = () => {
    setSelectedUser(null); // reset selected user for new entry
    setIsModalOpen((prev) => !prev);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleEditUser = (user) => {
    setIsModalOpen((prev) => !prev);
    setSelectedUser(user);
  };

  const handleOpenConfirmDeletePopup = (user) => {
    setIsConfirmPopupOpen(true);
    setUserToDelete(user);
  };

  const handleViewUserClick = (id, name) => {
    console.log("usersAdmin name ", id);
    navigate(`/user-history/${id}`, {
      state: { name: name },
    });
  };

  const handleDeleteUser = async () => {
    try {
      setLoading(true);
      const data = await deleteUsers(userToDelete?.id);
      setToastMessage(data?.message || "User deleted successfully!");
      setToastType("success");
      setShowToast(true);
      await getUserLists();
    } catch (error) {
      setToastMessage(
        error?.message || "Error occurred while deleting the User.",
      );
      setToastType("error");
      setShowToast(true);
    } finally {
      setIsConfirmPopupOpen(false);
      setUserToDelete(null);
      setLoading(false);
    }
  };

  const validateUserUploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return app.post(
      "/user/api/client-api/admin/bulk-upload/validate",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  };

  const handleValidateFile = async () => {
    if (!selectedFile) return;

    try {
      setValidating(true);
      const res = await validateUserUploadFile(selectedFile);
      console.log("res", res);

      message.success("File validated successfully!");
      setIsPreValidateModalOpen(false);
      setIsValidationSuccessful(true);
    } catch (err) {
      const errorData = err?.response?.data;

      if (err.response?.status === 400 && errorData?.data?.errorRecords) {
        setValidationResult(errorData.data.errorRecords);
        setIsPreValidateModalOpen(false);
        setIsValidationModalOpen(true);
        setIsValidationSuccessful(false);
        // message.error("Validation failed.");
      } else {
        message.error(errorData?.message || "Validation failed.");
      }
    } finally {
      setValidating(false);
    }
  };

  // Template file download function
  const templateFiles = {
    csv: "/templates/user_template.csv",
    txt: "/templates/user_template.txt",
    xlsx: "/templates/user_template.xlsx",
  };

  const handleTemplateDownload = (format) => {
    setDownloadFormat(format);
    setIsDownloadModalOpen(true);
  };

  const confirmDownloadTemplate = () => {
    if (!downloadFormat) return;

    const link = document.createElement("a");
    link.href = templateFiles[downloadFormat];
    link.download = `user_template.${downloadFormat}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    message.success(`Template downloaded (${downloadFormat.toUpperCase()})`);
    setIsDownloadModalOpen(false);
    setDownloadFormat(null);
  };

  const fields = [
    {
      dataIndex: "employeeId",

      title: (
        <div style={{ paddingLeft: 48, textAlign: "left" }}>Employee Id</div>
      ),
      key: "employeeId",
      ellipsis: true,
      width: 100,
      onCell: () => ({
        style: {
          textAlign: "left",
          paddingLeft: "48px",
        },
      }),
      align: "left",
    },
    {
      title: "Name",
      key: "name",
      dataIndex: "firstName",
      width: 100,
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      dataIndex: "manager",
      title: "Manager",
      key: "manager",
      width: 100,
    },
    {
      dataIndex: "email",
      title: "E-Mail",
      key: "email",
      width: 150,
    },
    {
      dataIndex: "role",
      title: "Role",
      key: "role",
      width: 80,
      align: "center",
      render: (role) => {
        const roleStyles = {
          employee: {
            color: "rgba(100, 37, 151, 1)",
            background: "rgba(249, 242, 255, 1)",
            borderColor: "rgba(175, 121, 219, 1)",
          },
          manager: {
            color: "rgba(145, 14, 17, 1)",
            background: "rgba(249, 243, 243, 1)",
            borderColor: "rgba(243, 163, 175, 1)",
          },
          admin: {
            color: "rgba(231, 72, 96, 1)",
            background: "rgba(254, 246, 247, 1)",
            borderColor: "rgba(211, 159, 160, 1)",
          },
          default: {
            color: "gray",
            background: "rgba(240, 240, 240, 1)",
          },
        };

        const roleKey = role?.toLowerCase();
        const { color, background, borderColor } =
          roleStyles[roleKey] || roleStyles.default;
        return (
          <Tag
            style={{
              color,
              backgroundColor: background,
              borderColor,
              padding: "10px 16px",
              borderRadius: "10px",
              border: "1px solid",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            {role
              ? role.charAt(0).toUpperCase() + role.slice(1)
              : "Not Defined"}
          </Tag>
        );
      },
    },
    !isInactive && {
      title: "Actions",
      key: "actions",
      width: 50,
      align: "center",
      render: (text, record) => {
        const popoverContent = (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Button
              className="navbar-item"
              onClick={() => {
                handleViewUserClick(
                  record?.id,
                  record?.firstName + " " + record?.lastName,
                );
                setVisiblePopover(null);
              }}
              onMouseEnter={() => setHoveredButton("view")}
              onMouseLeave={() => setHoveredButton(null)}
              style={{ width: "11rem" }}
            >
              <span>View</span>
              {hoveredButton === "view" ? (
                <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
              ) : (
                <img src={viewIcon} alt="view-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                handleEditUser(record);
                setVisiblePopover(null);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("edit")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>Edit</span>
              {hoveredButton === "edit" ? (
                <LottieIcon name="editIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={editIcon} alt="edit-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                setVisiblePopover(null);
                handleOpenConfirmDeletePopup(record);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("delete")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>Delete</span>
              {hoveredButton === "delete" ? (
                <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={deleteIcon} alt="delete-icon" height={28} />
              )}
            </Button>
          </div>
        );

        return (
          <CustomPopover
            content={popoverContent}
            trigger="click"
            className="admin-popover"
            placement="bottomRight"
            visible={visiblePopover === record.id}
            onVisibleChange={(visible) => {
              setVisiblePopover(visible ? record.id : null);
              if (!visible) setHoveredButton(null);
            }}
            getPopupContainer={() => document.body}
          >
            <MoreOutlined
              style={{ fontSize: "16px", color: "black", cursor: "pointer" }}
            />
          </CustomPopover>
        );
      },
    },
  ].filter(Boolean);

  const users = (isInactive ? inactiveUserList : userList) || [];
  // useEffect(() => {
  //   // setTotalElements(users.length);
  // }, [users.length]);

  const filteredUsers = users.filter((user) => {
    const search = searchText.toLowerCase();
    return (
      user.firstName?.toLowerCase().includes(search) ||
      user.lastName?.toLowerCase().includes(search) ||
      user.email?.toLowerCase().includes(search) ||
      user.username?.toLowerCase().includes(search) ||
      user.manager?.toLowerCase().includes(search)
    );
  });

  const processedUsers = filteredUsers.map((user, index) => ({
    id: user.userId,
    srNo: index + 1,
    employeeId: user.username,
    firstName: user.firstName,
    lastName: user.lastName,
    manager: user.manager || "N/A",
    email: user.email,
    role: user.role,
  }));

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const tabList = [
    {
      key: "1",
      label: "Active Users",
    },
    {
      key: "2",
      label: "Inactive Users",
    },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Handle tab switch explicitly (update `isInactive` state)
    setIsInactive((prev) => !prev);
    setCurrentPage(1);
  };

  return (
    <div className="user-container">
      {/* <Divider style={{ margin: '12px', color: 'black' }} /> */}
      <div className="user-table">
        <Row>
          <Col span={6}>
            <CustomTab entries={tabList} onChange={handleTabChange} />
          </Col>
          <Col span={18}>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <div
                onMouseEnter={() => setIsInputHovered(true)}
                onMouseLeave={() => setIsInputHovered(false)}
              >
                <CustomInput
                  icon={
                    isInputHovered ? (
                      <LottieIcon
                        name="searchIcon"
                        size={24}
                        shouldPlay={true}
                      />
                    ) : (
                      <img
                        src={searchIconsvg}
                        alt="search"
                        className="w-6 h-6"
                      />
                    )
                  }
                  className="!w-[250px]"
                  onChange={(e) => handleSearch(e.target.value)}
                  placeholder="Search employee"
                  allowClear
                />
              </div>
              <CustomButton
                icon={<UserAddOutlined />}
                onClick={() => setIsAddModalOpen(true)}
                variant={isInactive ? "disabled" : "primary"}
                disabled={isInactive}
              >
                New User
              </CustomButton>
              <CustomButton
                icon={<ExportOutlined />}
                onClick={() => navigate("/user-report")}
                variant={ "primary"}
          
              >
                User Report
              </CustomButton>
            </div>
          </Col>
          <Row>
            <div
              className="table-container"
              style={{
                width: "100%",
              }}
            >
              {activeTab === "1" &&
                (processedUsers.length > 0 ? (
                  <CommonTable
                    data={processedUsers}
                    columns={fields}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalElements,
                      showSizeChanger: true,
                    }}
                    onChange={handleTableChange}
                    serverSide={true}
                  />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No active users found"
                  />
                ))}

              {activeTab === "2" &&
                (processedUsers.length > 0 ? (
                  <CommonTable
                    data={processedUsers}
                    columns={fields}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalElements,
                      showSizeChanger: true,
                    }}
                    onChange={handleTableChange}
                    serverSide={true}
                  />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No inactive users found"
                  />
                ))}
            </div>
          </Row>
        </Row>
      </div>

      <UsersModal
        title={selectedUser ? "Edit Employee Details" : "Add New Employee"}
        isModalOpen={isModalOpen}
        getUserLists={getUserLists}
        handleCloseModal={handleCloseModal}
        selectedUser={selectedUser}
        setToastMessage={setToastMessage}
        setToastType={setToastType}
        setShowToast={setShowToast}
        setLoading={setLoading}
      />

      <Toast
        message={toastMessage}
        type={toastType}
        show={showToast}
        onClose={() => setShowToast(false)}
      />

      <ConfirmDeletePopup
        isOpen={isConfirmPopupOpen}
        onClose={() => setIsConfirmPopupOpen(false)}
        onConfirm={handleDeleteUser}
      />

      <PDFReaderModal
        isOpen={isReportModalOpen}
        pdfUrl={reportBlobUrl}
        onClose={() => {
          setIsReportModalOpen(false);
          URL.revokeObjectURL(reportBlobUrl);
          setSelectedUser(null);
        }}
        blockTime={0}
        showDownload={true}
        onDownloadPdf={handleDownloadPdf}
        onDownloadExcel={handleDownloadExcel}
      />

      {showOptionsModal && (
        <UserReportOptionsModal
          isOpen={showOptionsModal}
          onClose={() => setShowOptionsModal(false)}
          onSubmit={handleReportOptionsSubmit}
          userId={String(reportingUserId)}
        />
      )}
      {/* <Modal
        title="Before You Download"
        visible={isDownloadModalOpen}
        onCancel={() => setIsDownloadModalOpen(false)}
        onOk={confirmDownloadTemplate}
        okText="Download Template"
        cancelText="Cancel"
      >
      <p>
        Please ensure you enter all user details strictly in the format provided in
        the downloaded template.  
        Incorrect formatting may lead to errors during bulk upload.
      </p>
      <Table
        size="small"
        pagination={false}
        bordered
        dataSource={[
          {
            key: 1,
            firstName: "John",
            lastName: "Doe",
            manager: "Jane Smith",
            email: "john.doe@example.com",
            employeeId: "EMP001",
            role: "employee",
          },
        ]}
        columns={[
          { title: "First Name", dataIndex: "firstName", key: "firstName" },
          { title: "Last Name", dataIndex: "lastName", key: "lastName" },
          { title: "Email", dataIndex: "email", key: "email" },
          { title: "Employee Number", dataIndex: "employeeId", key: "employeeId" },
          { title: "Role", dataIndex: "role", key: "role" },
        ]}
        style={{ marginTop: 16 }}
      />
    </Modal> */}
      <CustomModal
        title="Bulk Upload Users"
        visible={isDownloadModalOpen}
        className="bulk-upload-modal"
        onClose={() => {
          setIsDownloadModalOpen(false);
          setDownloadFormat(null);
          setSelectedFile(null);
          setFileList([]);
        }}
      >
        <p
          style={{
            color: "rgba(70, 70, 70, 1)",
            fontSize: "14px",
          }}
        >
          Please ensure you enter all user details strictly in the format
          provided in the downloaded template. Incorrect formatting may lead to
          errors during bulk upload.
        </p>

        <Table
          size="small"
          pagination={false}
          bordered
          dataSource={[
            {
              key: 1,
              firstName: "John",
              lastName: "Doe",
              manager: "Jane Smith",
              email: "john.doe@nucleusteq.com",
              employeeId: "EMP001",
              role: "EMPLOYEE",
            },
            {
              key: 1,
              firstName: "Alice",
              lastName: "Johnson",
              manager: "Jane Smith",
              email: "alice.johnson@nucleusteq.com",
              employeeId: "EMP002",
              role: "MANAGER",
            },
          ]}
          columns={[
            { title: "First Name", dataIndex: "firstName", key: "firstName" },
            { title: "Last Name", dataIndex: "lastName", key: "lastName" },
            { title: "Email", dataIndex: "email", key: "email" },
            {
              title: "Employee Number",
              dataIndex: "employeeId",
              key: "employeeId",
            },
            { title: "Role", dataIndex: "role", key: "role" },
          ]}
          style={{ marginTop: 16, marginBottom: 16 }}
        />

        <Upload
          style={{
            width: "100%",
            height: "67px",
            marginTop: "10px",
          }}
          beforeUpload={async (file) => {
            setSelectedFile(file);
            setFileList([file]);
            try {
              setValidating(true);
              const res = await validateUserUploadFile(file);
              console.log("res", res);

              message.success("File validated successfully!");
              setIsValidationSuccessful(true);
            } catch (err) {
              const errorData = err?.response?.data;

              if (
                err.response?.status === 400 &&
                errorData?.data?.errorRecords
              ) {
                setValidationResult(errorData.data.errorRecords);
                setIsValidationModalOpen(true);
                setIsValidationSuccessful(false);
              } else {
                message.error(errorData?.message || "Validation failed.");
                // Remove file on validation failure
                setSelectedFile(null);
                setFileList([]);
              }
            } finally {
              setValidating(false);
            }
            return false; // prevent auto-upload
          }}
          onRemove={() => {
            setSelectedFile(null);
            setFileList([]);
            setIsValidationSuccessful(false);
          }}
          fileList={fileList}
          maxCount={1}
          accept={downloadFormat ? `.${downloadFormat}` : ""}
          showUploadList={false}
        >
          <div
            style={{
              border: "1px dashed rgba(222, 183, 183, 1)",
              borderRadius: "10px",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: "rgba(255, 255, 255, 1)",
              width: "100%",
            }}
          >
            {fileList.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 16px",
                  border: "1px dashed rgba(222, 183, 183, 1)",
                  backgroundColor: "rgba(249, 243, 243, 1)",
                  color: "rgba(145, 14, 17, 1)",
                  fontSize: "14px",
                  borderRadius: "10px",
                  fontWeight: 400,
                }}
              >
                <span>{fileList[0].name}</span>
                <img
                  src={closeIcon}
                  alt="remove"
                  style={{ width: 24, height: 24, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedFile(null);
                    setFileList([]);
                    setIsValidationSuccessful(false);
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  color: "rgba(145, 14, 17, 1)",
                  fontSize: "14px",
                  fontWeight: 400,
                  padding: "18px 0px ",
                }}
              >
                Upload File
              </div>
            )}
          </div>
        </Upload>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            width: "100%",
          }}
        >
          <CustomButton
            variant="primary"
            onClick={handleUploadSubmit}
            disabled={!selectedFile || !isValidationSuccessful}
            loading={uploading}
            className="!w-1/3"
          >
            Submit
          </CustomButton>

          <CustomButton
            variant="primary"
            onClick={confirmDownloadTemplate}
            disabled={!downloadFormat}
            className="!w-1/3"
          >
            Download Template
          </CustomButton>

          <CustomButton
            variant="outlined"
            onClick={() => {
              setIsDownloadModalOpen(false);
              setDownloadFormat(null);
              setSelectedFile(null);
              setFileList([]);
            }}
            className="!w-1/3"
          >
            Cancel
          </CustomButton>
        </div>
      </CustomModal>
      <CustomModal
        visible={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Add User"
        destroyOnClose
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            padding: "20px 0",
          }}
        >
          <CustomButton
            variant="outlined"
            onClick={() => {
              setIsAddModalOpen(false);
              handleAddNew();
            }}
            className="!w-full !justify-start"
          >
            Add New User
          </CustomButton>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "7px",
            }}
          >
            <CustomSelector
              placeholder="User Bulk Upload"
              className="bulk-upload-selector"
              onChange={(value) => {
                setIsAddModalOpen(false);
                handleTemplateDownload(value);
              }}
              options={[
                { value: "csv", label: "CSV Template" },
                { value: "txt", label: "TXT Template" },
                { value: "xlsx", label: "XLSX Template" },
              ]}
            />
            <span
              style={{
                fontSize: "12px",
                color: "rgba(116, 116, 116, 1)",
              }}
            >
              Note: Only upload TXT, CSV, XLSX file for bulk users.
            </span>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        title="Validate File Before Uploading"
        visible={isPreValidateModalOpen}
        onCancel={() => setIsPreValidateModalOpen(false)}
        destroyOnClose
      >
        <p>
          You have selected a file for upload. Before uploading, please validate
          that the file is in the correct format and contains no duplicate
          records.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            width: "100%",
          }}
        >
          <CustomButton
            variant="primary"
            className="!w-1/2"
            loading={validating}
            onClick={handleValidateFile}
          >
            Validate File
          </CustomButton>

          <CustomButton
            variant="outlined"
            className="!w-1/2"
            onClick={() => setIsPreValidateModalOpen(false)}
          >
            Cancel
          </CustomButton>
        </div>
      </CustomModal>
      <CustomModal
        visible={isValidationModalOpen}
        title={
          <span>
            <ExclamationCircleOutlined
              style={{ color: "#faad14", marginRight: 8 }}
            />
            Selected File Validation Failed
          </span>
        }
        onCancel={() => {
          setIsValidationModalOpen(false);
          setValidationResult(null);
        }}
      >
        <Alert
          type="warning"
          message={`Validation failed. ${
            validationResult?.length || 0
          } error record(s) found.`}
          description="Please review the errors in your file. You can download the error CSV to fix and re-upload."
          showIcon
          style={{ marginBottom: 16 }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            padding: "0px 0px 12px 0px",
          }}
        >
          {validationResult?.length > 0 && (
            <CustomButton
              className="!w-1/2"
              key="download"
              variant="primary"
              icon={<FileExcelOutlined />}
              onClick={() => {
                const headers = [
                  "rowNumber",
                  "firstName",
                  "lastName",
                  "email",
                  "employeeId",
                  "role",
                  "errors",
                ];
                const rows = validationResult.map((record) => [
                  record.rowNumber,
                  record.firstName,
                  record.lastName,
                  record.email,
                  record.employeeId,
                  record.role,
                  record.errors.join("; "),
                ]);
                const csv = [
                  headers.join(","),
                  ...rows.map((r) => r.map((val) => `"${val}"`).join(",")),
                ].join("\n");
                const blob = new Blob([csv], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "user_validation_errors.csv";
                link.click();
              }}
            >
              Download Error CSV
            </CustomButton>
          )}

          <CustomButton
            className="!w-1/2"
            key="close"
            variant="outlined"
            onClick={() => {
              setIsValidationModalOpen(false);
              setValidationResult(null);
            }}
          >
            Close
          </CustomButton>
        </div>
      </CustomModal>
    </div>
  );
};

export default AdminHOC(UsersAdmin);
